import styled from 'styled-components';
import { Colors } from '../../shared/colors/colors';


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 10px;
  background-color: ${Colors.backgroundColorModalBody};
`;

export const ErrorCode = styled.h1`
  font-size: 120px;
  color: ${Colors.primary};
  margin: 0;
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
`;

export const Title = styled.h2`
  font-size: 32px;
  color: ${Colors.primary};
  margin: 20px 0;
  text-align: center;
`;

export const Message = styled.p`
  font-size: 18px;
  color: ${Colors.secondary};
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.5;
`;

export const Button = styled.button`
  margin-top: 30px;
  padding: 12px 24px;
  background-color: ${Colors.primary};
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${Colors.primary};
  }
`;

export const IconContainer = styled.div`
  font-size: 64px;
  color: ${Colors.primary};
  margin: 20px 0;
`;